var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "新增",
        visible: _vm.dialogVisible,
        width: "600px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "clearanceMode", label: "清关模式" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择清关模式",
                              },
                              model: {
                                value: _vm.form.clearanceMode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "clearanceMode", $$v)
                                },
                                expression: "form.clearanceMode",
                              },
                            },
                            _vm._l(_vm.clearanceModesOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { prop: "systemFileId" } }, [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(" 上传文件 ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "upload" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                staticStyle: { "margin-left": "16px" },
                                attrs: {
                                  action: `api/InvoiceTemplate/SaveSupplierTemplate?supplierId=${_vm.supplierId}&clearanceMode=${_vm.form.clearanceMode}`,
                                  headers: _vm.headers,
                                  "file-list": _vm.fileList,
                                  "show-file-list": false,
                                  "on-success": _vm.onSuccess,
                                  "on-error": _vm.onError,
                                  "before-upload": _vm.beforeUpload,
                                  accept: ".xlsx",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { size: "small" },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        iconClass: "upload",
                                        className: "icon",
                                      },
                                    }),
                                    _vm._v(" 上传预报模板 "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }